import React, { forwardRef, ButtonHTMLAttributes } from "react";

import classnames from "classnames";

import {
  StyledAddCrossIcon,
  StyledAddToListButton,
  StyledText,
} from "./Styles";

export interface IAddToListButton
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Text to display */
  text: string;
  /** CSS classes */
  className?: string;
}

export const AddToListButton = forwardRef<HTMLButtonElement, IAddToListButton>(
  ({ text, className, ...rest }, ref) => {
    return (
      <StyledAddToListButton
        ref={ref}
        className={classnames("c--add-to-list-btn", className)}
        {...rest}
      >
        <StyledAddCrossIcon />
        <StyledText weight="medium">{text}</StyledText>
      </StyledAddToListButton>
    );
  }
);

AddToListButton.displayName = "AddToListButton";
